module.exports = {
      id: "down-arrow-usage",
      viewBox: "0 0 9.887 6",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#down-arrow",
      toString: function () {
        return this.url;
      }
    }